import * as React from "react";
import { createContext } from "react";
import {
  PatientComputedFields,
  PatientStateFields,
  useCreatePatientStateProvider,
} from "./useCreatePatientStateProvider";

export type UsePatientApi = Omit<
  PatientStateFields & PatientComputedFields,
  "computed"
>;

export const patientContextObject = createContext(null);

export interface PatientContextProps {
  children?: React.ReactNode;
  sessionId?: string;
}
let patientStore;
export const PatientContext = React.memo(
  ({ children = null, sessionId = null }: PatientContextProps) => {
    patientStore = useCreatePatientStateProvider(sessionId);
    return <>{children}</>;
  },
);

const patientStoreProxy = new Proxy<UsePatientApi>({} as any, {
  get: (target, field) => {
    return patientStore((store) => {
      return store.computed[field as keyof UsePatientApi] !== undefined
        ? store.computed[field as keyof UsePatientApi]
        : store[field as keyof UsePatientApi];
    });
  },
});

export const usePatient = () => {
  if (!patientStore) return {} as UsePatientApi;
  return patientStoreProxy;
};
